export interface RouteStop {
  name: string;
  type: string;
  duration: string;
}

export interface CityRoute {
  id: string;
  titleKey: string;
  descKey: string;
  durationHours: number;
  stopCount: number;
  difficulty: "easy" | "medium" | "hard";
  image: string;
  color: string;
  stops: RouteStop[];
  category: string;
}

export const cityRoutes: CityRoute[] = [
  {
    id: "one-day-bursa",
    titleKey: "routes_day1_title",
    descKey: "routes_day1_desc",
    durationHours: 8,
    stopCount: 8,
    difficulty: "easy",
    image: "https://public.readdy.ai/ai/img_res/a3dd9d2f8bf6ca5e2e24c12ba1c5341d.jpg",
    color: "forest",
    category: "Genel",
    stops: [
      { name: "Ulu Cami", type: "Tarihi", duration: "45 dk" },
      { name: "Hanlar Bölgesi", type: "Tarihi", duration: "1 sa" },
      { name: "Kebapçı İskender", type: "Yemek", duration: "1 sa" },
      { name: "Yeşil Cami", type: "Tarihi", duration: "30 dk" },
      { name: "Yeşil Türbe", type: "Tarihi", duration: "30 dk" },
      { name: "Teleferik", type: "Doğa", duration: "2 sa" },
      { name: "Extrempark", type: "Eğlence", duration: "2 sa" },
      { name: "Çekirge Termal", type: "Konaklama", duration: "1 sa" },
    ],
  },
  {
    id: "historical-bursa",
    titleKey: "routes_history_title",
    descKey: "routes_history_desc",
    durationHours: 10,
    stopCount: 12,
    difficulty: "medium",
    image: "https://readdy.ai/api/search-image?query=Bursa%20Osmangazi%20historical%20Ottoman%20architecture%20mosque%20mausoleum%20stone%20buildings%20ancient%20bazaar%20covered%20market%20warm%20tones%20heritage%20UNESCO&width=600&height=380&seq=route002&orientation=landscape",
    color: "stone",
    category: "Tarih",
    stops: [
      { name: "Osman Gazi Türbesi", type: "Tarihi", duration: "30 dk" },
      { name: "Ulu Cami", type: "Tarihi", duration: "1 sa" },
      { name: "Kapalı Çarşı", type: "Kültür", duration: "1 sa" },
      { name: "Hanlar Bölgesi", type: "Tarihi", duration: "1.5 sa" },
      { name: "Yeşil Cami", type: "Tarihi", duration: "45 dk" },
      { name: "Yeşil Türbe", type: "Tarihi", duration: "30 dk" },
      { name: "Cumalıkızık", type: "Kültür", duration: "2 sa" },
    ],
  },
  {
    id: "food-tour",
    titleKey: "routes_food_title",
    descKey: "routes_food_desc",
    durationHours: 6,
    stopCount: 7,
    difficulty: "easy",
    image: "https://readdy.ai/api/search-image?query=Turkish%20food%20tour%20Bursa%20iskender%20kebab%20tahinli%20pide%20local%20cuisine%20restaurant%20street%20food%20market%20fresh%20ingredients%20warm%20appetizing&width=600&height=380&seq=route003&orientation=landscape",
    color: "sage",
    category: "Lezzet",
    stops: [
      { name: "Cumalıkızık Kahvaltısı", type: "Kahvaltı", duration: "1.5 sa" },
      { name: "Kapalı Çarşı Tatları", type: "Atıştırma", duration: "45 dk" },
      { name: "Kebapçı İskender", type: "Öğle", duration: "1 sa" },
      { name: "Tahinli Pide Ustası", type: "Atıştırma", duration: "30 dk" },
      { name: "Güneşli Pastanesi", type: "Tatlı", duration: "30 dk" },
      { name: "Extrempark Terası", type: "Kahve", duration: "1 sa" },
      { name: "Pideciler Çarşısı", type: "Akşam", duration: "1 sa" },
    ],
  },
  {
    id: "family-route",
    titleKey: "routes_family_title",
    descKey: "routes_family_desc",
    durationHours: 8,
    stopCount: 6,
    difficulty: "easy",
    image: "https://readdy.ai/api/search-image?query=family%20adventure%20park%20Bursa%20children%20nature%20park%20fun%20outdoor%20activities%20Uludag%20cable%20car%20scenic%20green%20forest%20summer%20holiday%20Turkey&width=600&height=380&seq=route004&orientation=landscape",
    color: "forest",
    category: "Aile",
    stops: [
      { name: "Cumalıkızık", type: "Kültür", duration: "1.5 sa" },
      { name: "Bursa Botanik Parkı", type: "Doğa", duration: "1 sa" },
      { name: "Öğle Yemeği", type: "Yemek", duration: "1 sa" },
      { name: "Teleferik", type: "Eğlence", duration: "1.5 sa" },
      { name: "Extrempark", type: "Macera", duration: "2 sa" },
      { name: "İskender Yemeği", type: "Akşam", duration: "1 sa" },
    ],
  },
  {
    id: "weekend-plan",
    titleKey: "routes_weekend_title",
    descKey: "routes_weekend_desc",
    durationHours: 18,
    stopCount: 15,
    difficulty: "medium",
    image: "https://readdy.ai/api/search-image?query=Bursa%20weekend%20travel%20guide%20Turkey%20mountain%20city%20view%20Uludag%20scenery%20green%20nature%20historical%20mosques%20hotels%20sunset%20panorama&width=600&height=380&seq=route005&orientation=landscape",
    color: "stone",
    category: "Hafta Sonu",
    stops: [
      { name: "Ulu Cami", type: "Tarihi", duration: "45 dk" },
      { name: "Hanlar Bölgesi", type: "Tarihi", duration: "1 sa" },
      { name: "İskender Kebap", type: "Yemek", duration: "1 sa" },
      { name: "Kapalı Çarşı", type: "Alışveriş", duration: "1 sa" },
      { name: "Yeşil Cami", type: "Tarihi", duration: "30 dk" },
      { name: "Cumalıkızık", type: "Kültür", duration: "2 sa" },
      { name: "Termal Otel", type: "Konaklama", duration: "1 gece" },
      { name: "Teleferik", type: "Doğa", duration: "1.5 sa" },
      { name: "Extrempark", type: "Macera", duration: "3 sa" },
    ],
  },
];
